/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warning_AttentionInputs */

const en_warning_attention = /** @type {(inputs: Warning_AttentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attention:`)
};

const de_warning_attention = /** @type {(inputs: Warning_AttentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achtung:`)
};

/**
* | output |
* | --- |
* | "Attention:" |
*
* @param {Warning_AttentionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warning_attention = /** @type {((inputs?: Warning_AttentionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warning_AttentionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_warning_attention(inputs)
	return en_warning_attention(inputs)
});